export const CHECKOUT_BE_VALIDATION_GATE = 'Checkout:CheckoutInputValidationV2Gate';
export const CPQ_PRODUCTS_TIERS_ALPHA_GATE = 'Cpq:Products:TiersAlpha';
export const CHECKOUT_CHECKBOX_GATE = 'Checkout:Checkbox';
export const CREDIT_MEMOS_GATE = 'commerce:invoices:creditMemos';